import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section className="bg-brand-alt px-4 py-16 md:py-24" data-id="element-117" data-mp="1mg3onjp8stcz">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-118" data-mp="1hnu1ucjfc9ex">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/12 text-brand-orange" data-id="element-119" data-mp="1hm98urcrcyj6">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-120" data-mp="1ref01yv6rbxb" />
        </div>
        <h2 className="mb-9 text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-121" data-mp="25doeou3qtxz6">What You Get Immediately</h2>
        <ul className="space-y-3 text-left" data-id="element-122" data-mp="20etmj1jvyx2e">
          {instantAccessItems.map(item => <li key={item} className="flex items-start gap-4 rounded-2xl border border-brand-dark bg-brand-main p-5 shadow-sm" data-id="element-123" data-mp="aznea4sjp2wz">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-124" data-mp="62dm4hdrud5g" />
              <span className="text-[15px] font-semibold leading-snug" data-id="element-125" data-mp="2mzkgale10n7j">{item}</span>
            </li>)}
        </ul>
        <p className="mt-8 font-serif text-2xl font-bold italic text-brand-orange" data-id="element-126" data-mp="2x04knwwue7tz">
          Everything organized in one place — ready whenever you teach.
        </p>
        <div className="mx-auto mt-8 flex w-full max-w-sm flex-col items-center" data-id="element-127" data-mp="31rw4lolhtfb5">
          <CTAButton className="w-full" data-id="element-128" data-mp="35rmyw2a8adkf">GET INSTANT ACCESS</CTAButton>
          <p className="mt-2.5 text-xs font-semibold text-brand-gray" data-id="element-129" data-mp="3aqgcrvtfg6l4">
            Instant digital access • One-time payment • Lifetime access
          </p>
        </div>
      </Reveal>
    </section>;
}